import Dropdown from "../Elements/Dropdown";
import PropTypes from "prop-types";

const MilestoneCheckCard = ({
  title,
  status,
  id,
  toggleMilestoneStatus,
  milestoneDropdown,
}) => {
  return (
    <div
      className={`px-3 py-1 card-base card-base-background card-base-border flex gap-2 justify-between bg-salate-50 min-w-0 overflow-hidden`}
    >
      <label className="flex items-center space-x-2 gap-2 min-w-0 flex-1 cursor-pointer">
        <input
          type="checkbox"
          checked={status}
          onChange={() => toggleMilestoneStatus(id)}
          className="h-4 w-4 flex-shrink-0 cursor-pointer"
        />
        <p className={`text-sm ${status ? "line-through" : ""} truncate min-w-0 mobile-text-truncate`}>{title}</p>
      </label>
      {milestoneDropdown && (
        <div className="flex items-center flex-shrink-0 ml-2">
          <Dropdown options={milestoneDropdown(id)} />
        </div>
      )}
    </div>
  );
};

MilestoneCheckCard.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  toggleMilestoneStatus: PropTypes.func.isRequired,
  milestoneDropdown: PropTypes.func,
};

export default MilestoneCheckCard;
